import React, { useState } from 'react';
import { useAcademy } from '../AcademyContext';

/**
 * Access gate for the Academy. Members unlock their personal Academy with a
 * secret key (no email/password). Mirrors the Research password gate, but the
 * key resolves to an individual member + progress vault.
 */
const AcademyGate = () => {
  const { login, authError } = useAcademy();
  const [key, setKey] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      await login(key);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ac-gate">
      <div className="ac-gate-card">
        <img
          src="/img/sg_bonusclub_combo_white.png"
          alt="SalesGod · BonusClub"
          className="ac-gate-logo"
        />
        <span className="ac-gate-eyebrow">Academy Access</span>
        <h1 className="ac-gate-title">Enter your access key</h1>
        <p className="ac-gate-sub">
          Your personal key unlocks your courses and saves your progress. You can find it in your
          welcome message.
        </p>

        <form className="ac-gate-form" onSubmit={submit}>
          <input
            type="text"
            className="ac-gate-input"
            placeholder="XXXX-XXXX-XXXX-XXXX"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            autoFocus
            autoComplete="off"
            spellCheck={false}
          />
          {authError && <p className="ac-gate-error">{authError}</p>}
          <button type="submit" className="ac-gate-btn" disabled={busy}>
            {busy ? 'Checking…' : 'Unlock Academy'}
          </button>
        </form>

        <p className="ac-gate-foot">No key yet? Contact your SalesGod coach to get access.</p>
      </div>
    </div>
  );
};

export default AcademyGate;
